<template>
    <div>
        <div class="hero-section">
            <div class="container">
                <h1 class="page-title">{{ comp.task }}</h1>
                <p class="page-subtitle">
                    {{ comp.f1 }}
                </p>
            </div>
        </div>

        <div class="d-flex justify-content-center bg-white">
            
            <div style="max-width: 1200px !important; width: 100% !important">
                
                <!-- Main infographic title -->
                <!-- <div class="text-center my-5">
                    <h3 class="infographic-title">{{ comp.task }}</h3>
                </div> -->

                <!-- Degree Distribution Charts -->
                <div class="my-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <DegreeDistributionChart />
                </div>
                <!-- Edu Distribution Charts -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <EduDistributionChart />
                </div>

                <!-- Gender Distribution Charts -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <GenderDistributionChart />
                </div>

                <!-- Age Distribution Charts -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <AgeDistributionChart />
                </div>

                <!-- Regional Distribution Charts -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <RegionalDistributionChart />
                </div>

                <!-- University Ranking Chart -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <UniversityRankingChart />
                </div>

                <!-- 2025 Statistics Section -->
                <!-- <div class="statistics-section mb-5 bd rounded shadow bg-white">
                    <div class="row">
                        <div class="col-md-6">
                            <h3 class="text-center mb-4">Нийт мэргэшсэн, зөвлөх</h3>
                            <div class="pie-charts-container">
                                <div class="row">
                                    <div class="col-6">
                                        <h5 class="text-center">Тоогоор харуулах</h5>
                                        <div class="legend-item">
                                            <span class="legend-color" style="background-color: #F6E05E;"></span>
                                            Газар зохион байгууллт мэргэшсэн инженер
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="text-center">Хувиар харуулах</h5>
                                        <div class="legend-item">
                                            <span class="legend-color" style="background-color: #4299E1;"></span>
                                            Газар зохион байгуулалтын зөвлөх инженер
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h3 class="text-center mb-4">2025 онд сургалтанд хамрагдсан мэргэжилтнүүд</h3>
                            <div class="training-stats">
                                <div class="stats-container">
                                    <h4>Мэргэшсэн, Зөвлөх горилох</h4>
                                    <p class="text-center">Тоогоор харуулах</p>
                                    <div class="progress-bars">
                                        <div class="progress-item">
                                            <span>Газар зохион байгууллт</span>
                                            <span>60%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Газрын кадастрын</span>
                                            <span>90%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Геодезийн хэмжилт, зурагтялын</span>
                                            <span>80%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Зурагзүй</span>
                                            <span>50%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="stats-container">
                                    <h4>Мэргэшсэн, Зөвлөх зэрэг сунгасан</h4>
                                    <p class="text-center">Хувиар харуулах</p>
                                    <div class="progress-bars">
                                        <div class="progress-item">
                                            <span>Газар зохион байгууллт</span>
                                            <span>60%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Газрын кадастрын</span>
                                            <span>90%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Геодезийн хэмжилт, зурагтялын</span>
                                            <span>80%</span>
                                        </div>
                                        <div class="progress-item">
                                            <span>Зурагзүй</span>
                                            <span>50%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Water Quality Chart -->
                <div class="mb-5" style="background: #f0f6ff !important; border-radius: 10px !important;">
                    <WaterQualityChart />
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import DegreeDistributionChart from './graphs/DegreeDistributionChart.vue'
import GenderDistributionChart from './graphs/GenderDistributionChart.vue'
import AgeDistributionChart from './graphs/AgeDistributionChart.vue'
import EduDistributionChart from './graphs/EduDistributionChart.vue'

import RegionalDistributionChart from './graphs/RegionalDistributionChart.vue'
import UniversityRankingChart from './graphs/UniversityRankingChart.vue'
import WaterQualityChart from './graphs/WaterQualityChart.vue'

export default {
  name: "Infographic",
  components: {
    DegreeDistributionChart,
    GenderDistributionChart,
    AgeDistributionChart,
    EduDistributionChart,
    RegionalDistributionChart,
    UniversityRankingChart,
    WaterQualityChart
  },
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>



.hero-section {
  background: 
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('https://res.gosmart.mn/apps/egazar/cover6.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* filter: grayscale(100%); */
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.page-subtitle {
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.infographic-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2D3748;
  margin-bottom: 2rem;
}

.statistics-section {
  background-color: #f8f9fa;
  padding: 30px;
  border-radius: 12px;
  margin: 30px 0;
}

.pie-charts-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 8px;
}

.training-stats {
  display: flex;
  gap: 20px;
}

.stats-container {
  flex: 1;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.progress-bars {
  margin-top: 15px;
}

.progress-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.progress-item:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .infographic-title {
    font-size: 1.8rem;
  }
  
  .training-stats {
    flex-direction: column;
  }
}
</style>